import React from 'react';
import { Link } from 'react-router-dom';

// TODO: Replace with Pagination component from Solon.
const Pagination = ({ totalResults = 0, perPage = 20, currentPage = 0, filters = [], pathName = '/search' }) => {
    let pages = Math.ceil(totalResults / perPage);
    let maxPagesShown = 5;
    let half = Math.ceil(maxPagesShown / 2);

    // UGH this is a terrible variable name.
    let cp = (currentPage + perPage) / perPage;

    const isFirst = cp === 1;
    const isLast = cp === pages;

    let begin = cp < half ? 0 : cp - half;
    let end = cp < half ? maxPagesShown : cp + (half - 1);

    let pa = [];
    for (var i = 0; i < pages; i++) {
        pa.push(i + 1);
    }

    return (
        <div>
            <ul className="pagination">
                {!isFirst && (
                    <li className="page-back">
                        <Link
                            to={{
                                pathname: pathName,
                                search: new URLSearchParams({ ...filters, start: currentPage - perPage }).toString()
                            }}
                        >
                            Prev
                        </Link>
                    </li>
                )}
                {pa.slice(begin, end).map((p) => {
                    let start = perPage * (p - 1);
                    let current = start === currentPage;
                    return (
                        <li key={`page_${p}`} className={current ? 'current' : null}>
                            {current ? (
                                <span>{p}</span>
                            ) : (
                                <Link
                                    to={{
                                        pathname: pathName,
                                        search: new URLSearchParams({ ...filters, start: start }).toString()
                                    }}
                                >
                                    {p}
                                </Link>
                            )}
                        </li>
                    );
                })}
                {!isLast && (
                    <li className="page-fwd">
                        <Link
                            to={{
                                pathname: pathName,
                                search: new URLSearchParams({ ...filters, start: currentPage + perPage }).toString()
                            }}
                        >
                            Next
                        </Link>
                    </li>
                )}
            </ul>
        </div>
    );
};

export default Pagination;
